import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import { CompanyApi } from "@/domain";
import { MODAL_HANDLER } from "@/lib/Mantine";
import { router } from "@/main";

import { nextCargoApi } from "../../baseApi";
import { driverApi } from "../driver/driver.api";
import { LoginDriver, LoginExped, SaveRegisterDriver } from "./auth.types";

type ApiLikeError = {
  name?: string;
  status?: unknown;
  data?: {
    driver?: { id?: string };
    company_a?: CompanyApi & {
      queue?: { date?: string };
    };
  };
};

export const REGISTER_DRIVER_CACHE_KEY = "save-register-driver";
export const authApi = nextCargoApi.injectEndpoints({
  endpoints: (builder) => ({
    loginDriver: builder.mutation<LoginDriver["result"], LoginDriver["args"]>({
      query: (body) => ({
        url: "/auth/app/login",
        method: "POST",
        body
      }),
      onQueryStarted: async (args, { queryFulfilled, dispatch }) => {
        try {
          await queryFulfilled;
        } catch (err: unknown) {
          const errorObj = typeof err === "object" && err !== null ? err : {};
          const nestedError = "error" in errorObj ? (errorObj.error as ApiLikeError | undefined) : undefined;
          const isAbortError = nestedError?.name === "AbortError" || ("name" in errorObj && errorObj.name === "AbortError");

          if (isAbortError) return;

          const companyItem = sessionStorage.getItem("@company");
          const company = companyItem ? (JSON.parse(companyItem) as CompanyApi) : undefined;
          const driverId = nestedError?.data?.driver?.id;
          const errorStatus = nestedError?.status || ("status" in errorObj ? (errorObj.status as unknown) : undefined);
          const altCompany = nestedError?.data?.company_a;
          const queueDate = altCompany?.queue?.date;
          const statusCode = typeof errorStatus === "number" ? errorStatus : undefined;

          if (statusCode === 406) {
            const isAccepted = await new Promise<boolean>((resolve) => {
              MODAL_HANDLER.transferCompany({
                driver: { id: driverId! },
                company: company!,
                altCompany: altCompany!,
                queueDate: queueDate!,
                onAccept: () => resolve(true),
                onDimiss: () => resolve(false)
              });
            });

            if (!isAccepted) return;

            const { data } = await dispatch(authApi.endpoints.loginDriver.initiate(args));
            if (!data) return;
            router.navigate({ to: "/app" });
          }
        }
      },
      extraOptions: {
        maxRetries: 0
      }
    }),
    saveRegisterDriver: builder.mutation<SaveRegisterDriver["result"], SaveRegisterDriver["args"]>({
      queryFn: async (args, { dispatch }) => {
        console.log(args);
        try {
          const data = await dispatch(driverApi.endpoints.saveDriver.initiate(args, { fixedCacheKey: REGISTER_DRIVER_CACHE_KEY })).unwrap();
          return { data };
        } catch (error) {
          return { error: error as FetchBaseQueryError };
        }
      },
      extraOptions: {
        maxRetries: 1
      }
    }),
    loginExped: builder.mutation<LoginExped["result"], LoginExped["args"]>({
      query: (body) => ({
        url: "/auth/login",
        method: "POST",
        body
      })
    })
  })
});
